const BUBBLES = [
  { left: "6%", size: 18, dur: 14, delay: 0 },
  { left: "16%", size: 10, dur: 11, delay: 3 },
  { left: "28%", size: 26, dur: 17, delay: 6 },
  { left: "42%", size: 12, dur: 10, delay: 1.5 },
  { left: "55%", size: 20, dur: 15, delay: 8 },
  { left: "68%", size: 8, dur: 9, delay: 4 },
  { left: "80%", size: 24, dur: 16, delay: 2 },
  { left: "92%", size: 12, dur: 12, delay: 7 },
];

const SPARKS = [
  { left: "8%", h: 12, dur: 7, delay: 0 },
  { left: "18%", h: 8, dur: 5.5, delay: 2 },
  { left: "30%", h: 14, dur: 8, delay: 4 },
  { left: "45%", h: 9, dur: 6, delay: 1 },
  { left: "58%", h: 13, dur: 7.5, delay: 3.2 },
  { left: "70%", h: 8, dur: 5, delay: 5 },
  { left: "82%", h: 15, dur: 8.5, delay: 0.8 },
  { left: "93%", h: 10, dur: 6.5, delay: 2.6 },
];

const RINGS = [
  { size: 260, dur: 6, delay: 0 },
  { size: 260, dur: 6, delay: 2 },
  { size: 260, dur: 6, delay: 4 },
];

export function Bubbles() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="bg-bubbles">
      {BUBBLES.map((b, i) => (
        <span
          key={i}
          className="bubble"
          style={{ left: b.left, width: b.size, height: b.size, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}
        />
      ))}
    </div>
  );
}

export function Sparks() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="bg-sparks">
      {SPARKS.map((s, i) => (
        <span
          key={i}
          className="spark"
          style={{ left: s.left, height: s.h, animationDuration: `${s.dur}s`, animationDelay: `${s.delay}s` }}
        />
      ))}
    </div>
  );
}

const FRAMES = [
  { left: "7%", w: 90, h: 64, dur: 16, delay: 0 },
  { left: "22%", w: 56, h: 42, dur: 12, delay: 4 },
  { left: "48%", w: 110, h: 76, dur: 19, delay: 8 },
  { left: "70%", w: 64, h: 48, dur: 13, delay: 2 },
  { left: "88%", w: 96, h: 66, dur: 17, delay: 6 },
];

const FEW_BUBBLES = [
  { left: "10%", size: 16, dur: 15, delay: 1 },
  { left: "30%", size: 11, dur: 12, delay: 5 },
  { left: "47%", size: 24, dur: 19, delay: 6 },
  { left: "64%", size: 14, dur: 14, delay: 0 },
  { left: "82%", size: 12, dur: 13, delay: 3 },
];

export function FewBubbles() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="bg-few-bubbles">
      {FEW_BUBBLES.map((b, i) => (
        <span
          key={i}
          className="bubble"
          style={{ left: b.left, width: b.size, height: b.size, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}
        />
      ))}
    </div>
  );
}

export function FloatFrames() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="bg-float-frames">
      {FRAMES.map((f, i) => (
        <span
          key={i}
          className="float-frame"
          style={{ left: f.left, width: f.w, height: f.h, animationDuration: `${f.dur}s`, animationDelay: `${f.delay}s` }}
        />
      ))}
    </div>
  );
}

const BEAMS = [
  { left: "12%", dur: 11, delay: 0 },
  { left: "45%", dur: 14, delay: 4.5 },
  { left: "76%", dur: 9, delay: 2 },
];

export function Beams() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="bg-beams">
      {BEAMS.map((b, i) => (
        <span
          key={i}
          className="beam"
          style={{ left: b.left, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}
        />
      ))}
    </div>
  );
}

export function Sonar() {
  return (
    <div
      aria-hidden
      className="absolute right-[-80px] top-1/2 -translate-y-1/2 w-[260px] h-[260px] pointer-events-none hidden md:block"
      data-testid="bg-sonar"
    >
      {RINGS.map((r, i) => (
        <span
          key={i}
          className="sonar-ring inset-0"
          style={{ width: r.size, height: r.size, animationDuration: `${r.dur}s`, animationDelay: `${r.delay}s` }}
        />
      ))}
      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-2.5 h-2.5 rounded-full bg-[#007bff]" />
    </div>
  );
}

const CURRENTS = [
  { top: "18%", dur: 9, delay: 0 },
  { top: "34%", dur: 12, delay: 1.5 },
  { top: "52%", dur: 8, delay: 3 },
  { top: "68%", dur: 11, delay: 0.8 },
  { top: "84%", dur: 10, delay: 2.2 },
];

export function Currents() {
  return (
    <div aria-hidden className="absolute inset-0 overflow-hidden pointer-events-none" data-testid="bg-currents">
      {CURRENTS.map((c, i) => (
        <span
          key={i}
          className="current-line"
          style={{ top: c.top, left: `${(i % 2) * 30}%`, animationDuration: `${c.dur}s`, animationDelay: `${c.delay}s` }}
        />
      ))}
    </div>
  );
}
